import React from 'react'
import PropTypes from 'prop-types'
import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'
import { DEFAULT_DATE_FORMAT } from 'constants/date'

export default function InputDate(props) {
  const {
    value,
    label,
    id,
    onChange,
    format,
    name,
  } = props

  const handleChange = (datetime) => {
    onChange({ name, datetime })
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        name={name}
        margin="normal"
        id={id}
        label={label}
        format={format}
        value={value}
        onChange={handleChange}
        KeyboardButtonProps={{
          'aria-label': 'alterar data',
        }}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </MuiPickersUtilsProvider>
  )
}

InputDate.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
  format: PropTypes.string,
  name: PropTypes.string.isRequired,
}

InputDate.defaultProps = {
  label: 'Hora',
  value: new Date(),
  format: DEFAULT_DATE_FORMAT,
}
